import {
  GET_CLOSING_RATIO_DATA,
  SET_CLOSING_RATIO_LOADING,
  REMOVE_ITEM_FROM_DATA,
  GET_TEAM_CLOSING_RATIO_DATA,
  CALCULATE_PREDICTED_DATA,
  CLEAR_CLOSING_RATIO_DATA,
} from './closingRatioTypes'

const initState = {
  data: [],
  isLoading: false,
  predictedData: [],
}

const addOrReplacePredictionData = (state, action) => {
  const item = state.predictedData.find((i) => i.id === action.payload.id)
  if (item) {
    const newData = state.predictedData.filter((i) => i.id !== action.payload.id)
    return {
      ...state,
      predictedData: [...newData, action.payload],
    }
  } else {
    return {
      ...state,
      predictedData: [...state.predictedData, action.payload],
    }
  }
}

const removeItem = (state, action) => {
  return {
    ...state,
    data: state.data.filter((d) => d.id !== action.payload),
    predictedData: state.predictedData.filter((p) => p.id !== action.payload),
  }
}

export default (state = initState, action) => {
  switch (action.type) {
    case GET_CLOSING_RATIO_DATA:
      return {
        ...state,
        data: [action.payload, ...state.data],
      }
    case SET_CLOSING_RATIO_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }

    case REMOVE_ITEM_FROM_DATA:
      return removeItem(state, action)
    case GET_TEAM_CLOSING_RATIO_DATA:
      return {
        ...state.data,
        data: [...state, action.payload],
      }
    case CALCULATE_PREDICTED_DATA:
      return addOrReplacePredictionData(state, action)
    case CLEAR_CLOSING_RATIO_DATA:
      return initState
    default:
      return state
  }
}
